import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import {InputRow} from '../../../components'
import {getUserDataFromLocalStorage, onChangeInput, validateInputs} from "../../../services/utils";
import {useStyles} from "../../auth/signIn/authStyles";
import {initialState} from "./constant";
import Alert from "../../../components/alert";
import HttpService from "../../../services/http.service";

export default function AddNewAlert(props) {
  const classes = useStyles();
  let user = getUserDataFromLocalStorage()
  const [state, setState] = useState(initialState);

  const {values, errors} = state;

  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
   const [alertType, setAlertType] = useState([])
  useEffect(() => {
    console.log('change')
  }, [state])
 useEffect(() => {
    HttpService.get('apis/list/todoTypes/').then(res => {
      if (res) {

        const array = []
          for (let i = 0; i < res.data.length; i++) {
            array.push({text: res.data[i].activityName, value: res.data[i].myToDoActivitiesId})
          }
          setAlertType(array)
      }
    });
  }, []);
  const addAlert = (e) => {
    e.preventDefault();

    let data = {
      ...values
    };

    let recordedErrors = validateInputs(data);

    if (Object.keys(recordedErrors).length > 0) {
      console.log("error", recordedErrors);
      setState((prevState) => ({
        ...prevState,
        errors: recordedErrors,
      }));
    } else {

      HttpService.post(`apis/myalerts/?activity=${data.activity}&myToDoActivitiesId=${data.myToDoActivitiesId}&notifyByEmail=${data.notifyByEmail}&notifyBySMS=${data.notifyBySMS}&reminderDate=${data.reminderDate}&ssoId=${user.ssoId}`).then(res => {
        if (res) {
          if (res?.data?.message === "SUCCESS")
            setSuccess(res?.data?.messageText)
          setTimeout(() => {
            setSuccess("")
          }, 5000);
        } else
          setError(res?.data?.messageText)
        setTimeout(() => {
          setError("")
        }, 5000);
      });
    }
  };


  return (
    <>
      {/*<Header/>*/}
      {((error || success)) &&
      <Alert type={error ? 'error' : 'success'}
             message={error || success}/>
      }

      <Container component="main" maxWidth={"lg"} className='mb-20 '>
        <div>
          <h1 className='align-self-start'>New Alert</h1>
          <form className={classes.form}>
            <InputRow
              types={[
                {value: values.activity, error: errors.activity, id: 'activity', label: 'activity Name',},
                {
                  type: 'select',
                  value: values.myToDoActivitiesId,
                  error: errors.myToDoActivitiesId,
                  id: 'myToDoActivitiesId',
                  label: 'Alert Type',
                  dropdownList: alertType
                },
                {
                  type: 'select',
                  value: values.notifyByEmail,
                  error: errors.notifyByEmail,
                  label: 'notifyByEmail',
                  dropdownList: [{text:"Yes",value:"y"},{text:"No",value:"n"}]
                }, {
                  type: 'select',
                  value: values.notifyBySMS,
                  error: errors.notifyBySMS,
                  label: 'notifyBySMS',
                  id: 'notifyBySMS',
                  dropdownList: [{text:"Yes",value:"y"},{text:"No",value:"n"}]
                },
                {
                  type: 'date',
                  value: values.reminderDate,
                  error: errors.reminderDate,
                  label: 'reminderDate',
                },
              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={2}
            />

            <Grid container spacing={2} className='mt-30 mb-20 pl-10  pr-10'>
              <Grid item lg={6} xs={12} className='display-flex justify-content-end'>
                <br></br>
                <Button type="submit" variant="contained" color="primary"
                        onClick={(e) => addAlert(e)}>
                  Send Alert
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}
